export const ALL_ANNOTATIONS = "all_annotations";
export const ALL_DETERMINATIONS = "all_determinations";
export const ALL_REMEDIES = "all_remedies";
export const ALL_TERMS = "all_terms";
export const DOCUMENT_GUID = "document_guid";
export const ISSUE_ANNOTATIONS = "issue_annotations";
export const PDF_SNIPPET = "pdf_snippet";

// NOTE: Incomplete list. Only including fields for which the client has special behavior
